import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

const BDCRecap = ({ listBDC = [], title }) => {
  const { SearchBar } = Search;
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };
  const columns = [
    {
      dataField: "reference",
      text: "Reference",
      sort: true,
    },
    {
      dataField: "client.title",
      text: "Client",
      sort: true,
      formatter: (cell, row) => row.client?.title || "N/A",
    },
    {
      dataField: "montant",
      text: "Montant",
      sort: true,
      formatter: (cell) => `${cell.toFixed(2)}`,
    },
    {
      dataField: "creationDate",
      text: "Date de Création",
      sort: true,
      formatter: (cell) => new Date(cell).toLocaleDateString("fr-FR"),
    },
    {
      dataField: "etat",
      text: "Etat",
      formatter: (cell) => (cell==="yes" ? "Oui" : "Non"),
      sort: true,
    },
  ];

  const options = {
    sizePerPage: 5,
    hideSizePerPage: false,
    hidePageListOnlyOnePage: true,
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">{title}</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={listBDC}
          columns={columns}
          exportCSV
          search
        >
          {(props) => (
            <div>
            
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>
    </div>
  );
};


export default BDCRecap;
